import { normalizePermalink } from "./normalizePermalink";
import { parseAppUrl } from "./parseAppUrl";
import { isParserError } from "./parser.error";

export function getNormalizedPermalinkFromUrl(url: string) {
  let parsed;
  try {
    parsed = parseAppUrl(url);
  } catch (e) {
    if (!isParserError(e)) {
      console.error("Unexpected error during url parsing:", e);
    }
    return null;
  }

  return normalizePermalink(parsed);
}
